import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { SaleController } from 'src/controllers/sale.controller'
import { SaleDTO } from 'src/dto/sale'

const saleController = new SaleController()

export function useGetSaleList() {
  const { userFarm: farmId } = useAuth()

  return useQuery<SaleDTO[], Error>({
    queryKey: ['getSaleList', farmId],
    queryFn: () =>
      saleController.getSaleList(farmId!).then((response) => response.filter((sale) => sale.acao !== 'Removido')),
    enabled: !!farmId
  })
}
